import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React from "react";

interface ClearIconProps {
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
}

/**
 * Reusable clear icon component for all editor cells
 */
const t={
  clear: 'Clear'
}
export default function ClearIcon(props: ClearIconProps) {
  const { onClick, style } = props;

  return (
    <Tooltip title={t.clear}>
    <FontAwesomeIcon
      icon={["far", "times-circle"]}
      color="var(--gray-7)"
      size="sm"
      width={12}
      onClick={onClick}
      style={{ cursor: "pointer", padding: 0, ...style }}
      {...props}
    />
    </Tooltip>
  );
}
